<template>
	
	<el-tabs type="border-card" @tab-click="Tabclick" value="10">
	
		<!-- 待付款 -->
		<el-tab-pane label="待付款" name="0"></el-tab-pane>
		<!-- 待发货 -->
		<el-tab-pane label="待发货" name="10"></el-tab-pane>
		<!-- 待收货 -->
		<el-tab-pane label="待收货" name="20"></el-tab-pane>
		<!-- 已完成 -->
		<el-tab-pane label="已完成" name="30"></el-tab-pane>
		<!--  已关闭-->
		<el-tab-pane label="已关闭" name="5"></el-tab-pane>
		<!-- 申请退款 -->
		<el-tab-pane label="申请退款" name="6"></el-tab-pane>
		<!-- 已退款 -->
		<el-tab-pane label="已退款" name="7"></el-tab-pane>
		<!-- 退换货 -->
		<el-tab-pane label="退换货" name="15"></el-tab-pane>	
		<Dingdan ref="dingdan" m="my_mayiba"></Dingdan> 	
		
	</el-tabs>

</template>

<script>
	let that;
	import Dingdan from '../../zujian/Dingdan.vue'
	import dayin from '../../zujian/dayin.vue'
	export default {
		data() {
			return {	
						
			}
		},
		components: {
			Dingdan,
			dayin
		},
		created() {
			that = this;
			// that.CSH();
		},
		methods: {
			Tabclick(e){
				that.$refs.dingdan.so={ye: 1,jitiao: 10,zhuangtai:e.name};					
				that.$refs.dingdan.CSH();			
			},			
		}
	}
</script>

<style>
	.el-form-item__content {
		margin-left: 0 !important;
	}

	li {
		list-style: none;
	}

	ul {
		padding: 0;
	}

	.nei {
		padding: 49px 16px 14px 16px;
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
	}

	.annius {
		width:7.1875rem;
		display: flex;
		flex-wrap: wrap;
		position: relative;
	}
	.biaotou li{
		list-style: none;
		display: flex;
	}
	.dindanlie1{
		
	}
	.caozuo {
		/* width: 100%; */
	}

	.el-button+.el-button {
		margin-left: 0;
	}

	.shangping {
		width: 33%;
		/* display: flex; */
		/* justify-content: space-between; */
	}
	.shangping_box{display: flex; justify-content: flex-start;padding: 10px 0;}
	.shangping_box:not(:first-child){ border-top: 1px solid #ebebeb;}
	.jiage_box{font-size: 14px;color: #999999;}
	.f_right {
		margin-left: 10px;
		color: #666666;
		width: 80%;
	}
	.btn{
		/* padding: 6px 12px; */
		width: 82px;
		height: 34px;
		margin-bottom: 0;
		font-size: 14px;
		color: #FFFFFF;
		border-radius: 2px;
		line-height: 34px;
		text-align: center;
		cursor: pointer;
	}
	.shouhuo {
		width: 10%;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		font-size: 12px;
		text-align: center;
	}

	.jiage {
		width: 10%;
		font-size: 14px;
		color: #666666;
	}

	.zhuantai {
		width:6%;
	}

	.zhifu {
		display: flex;
		justify-content: center;
		padding-top: 40px;
	}

	.el-drawer__header {
		text-align: center;
	}

	.dingdan {
		padding: 0 400px;
	}

	.anniu {
		position: absolute;
		top: 0;
		right: 10px;
		width: 58px;
	}

	

	.el-form-item {
		/* margin-bottom: 0 !important; */
	}
</style>
